import styled from 'styled-components';

import { BoxesSliderSlideSize, Breakpoint, Color, DirectionEnum, FontWeight, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { hexToRgba } from '../../utils';
import { Badge } from '../badge/badge.component';
import { Image } from '../image/image.component';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { ArrowButtonProps, SlideBadgeProps, SlideImageProps, SlideItemProps } from './boxesSlider.types';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  position: relative;
`;

export const SlideItem: StyledComponent<'div', SlideItemProps> = styled.div<SlideItemProps>`
  margin-left: ${({ $isFirst }: SlideItemProps): string => $isFirst ? '40px' : '0'};

  & + & {
    margin-left: 10px;
  }

  @media ${Breakpoint.Tablet} {
    margin-left: ${({ $isFirst }: SlideItemProps): string => $isFirst ? '32px' : '0'};
  }

  @media ${Breakpoint.Mobile} {
    margin-left: ${({ $isFirst }: SlideItemProps): string => $isFirst ? '20px' : '0'};
  }
`;

export const SlideImage: StyledComponent<typeof Image, SlideImageProps> = styled(Image)<SlideImageProps>`
  height: ${({ $size }: SlideImageProps): string => $size === BoxesSliderSlideSize.Small ? '200px' : '300px'};
  min-width: 150px;
  width: auto;
`;

export const SlideItemWrapper: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const SlideDetails: StyledComponent<'div'> = styled.div`
  margin-top: 16px;
  font-weight: ${FontWeight.Regular};
  display: inline-block;
  width: 0;
  min-width: 100%;
  padding-right: 24px;
`;

export const SlideBadge: StyledComponent<typeof Badge, SlideBadgeProps> = styled(Badge)<SlideBadgeProps>`
  position: absolute;
  top: 12px;
  left: ${({ $isFirst }: SlideItemProps): string => $isFirst ? '52px' : '12px'};
  font-weight: ${FontWeight.Regular};

  @media ${Breakpoint.Tablet} {
    left: ${({ $isFirst }: SlideItemProps): string => $isFirst ? '44px' : '12px'};
  }

  @media ${Breakpoint.Mobile} {
    left: ${({ $isFirst }: SlideItemProps): string => $isFirst ? '32px' : '12px'};
  }
`;

export const ArrowButton: StyledComponent<'button', ArrowButtonProps> = styled.button.attrs<ArrowButtonProps>({ type: 'button' })`
  position: absolute;
  top: ${({ $size }: SlideImageProps): string => $size === BoxesSliderSlideSize.Small ? '72px' : '122px'};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${ZIndex.BoxesSliderArrows};
  width: 56px;
  height: 56px;
  background-color: ${Color.White};
  box-shadow: 0px 0px 4.375px ${hexToRgba(Color.Black, 0.15)};
  border-radius: 50%;
  transition: 0.3s;
  ${({ $position }: ArrowButtonProps): string => $position === DirectionEnum.Left ? 'left: 40px' : 'right: 40px'};
  ${({ $position }: ArrowButtonProps): string => $position === DirectionEnum.Left ? 'padding-right: 3px' : 'padding-left: 3px'};
  opacity: ${({ $visible }: ArrowButtonProps): string => $visible ? '1' : '0'};
  pointer-events: ${({ $visible }: ArrowButtonProps): string => $visible ? 'initial' : 'none'};

  @media ${Breakpoint.Tablet} {
    ${({ $position }: ArrowButtonProps): string => $position === DirectionEnum.Left ? 'left: 32px' : 'right: 32px'};
  }

  @media ${Breakpoint.Mobile} {
    ${({ $position }: ArrowButtonProps): string => $position === DirectionEnum.Left ? 'left: 20px' : 'right: 20px'};
  }
`;
